import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import { SendIcon } from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";
import CustomSvg from "../../../../shared/components/custom-svg/CustomSvg";
import DayToDayActivityIconMapping from "../../../../assets/icons/DayToDayActivityIconMapping";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";

const DayToDay = ({ allDayToDayActivity }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const selectedOptions = watch("dayToDay") || []; // Watch the "activity" field

  const [searchValue, setSearchValue] = useState(EMPTY_STRING);

  const handleSelection = (option) => {
    if (selectedOptions.includes(option.id)) {
      // If the option is already selected, remove it
      setValue(
        "dayToDay",
        selectedOptions.filter((selected) => selected !== option.id)
      );
    } else {
      // If the option is not selected, add it
      setValue("dayToDay", [...selectedOptions, option.id]);
    }
  };

  const getFilteredActivities = () => {
    const search = searchValue.trim();
    if (!search) {
      return allDayToDayActivity;
    } else {
      return allDayToDayActivity.filter((option) =>
        option.title.toLowerCase().includes(search.toLowerCase())
      );
    }
  };

  return (
    <div>
      <div className="question-heading">
        What does your day to day look like?
      </div>
      {errors.dayToDay && (
        <div className="error">{errors.dayToDay.message}</div>
      )}
      <div className="form-fields">
        <div className="w-85">
          <SurveyFormField
            textValue={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeHolder="type anything..."
            endAdornment={
              <div className="position-absolute send-icon-adornment">
                <img src={SendIcon} alt={EMPTY_STRING} />
              </div>
            }
          />
        </div>
        <div className="d-flex flex-wrap gap-2 gap-sm-4 rounded-options-container">
          {getFilteredActivities().map((option) => (
            <div
              className={`px-2 rounded-options pointer ${
                selectedOptions.includes(option.id)
                  ? "rounded-option-selected"
                  : ""
              }`}
              onClick={() => handleSelection(option)}
            >
              <CustomSvg
                src={DayToDayActivityIconMapping[option.icon]}
                className="d-flex pt-2 justify-content-center mx-auto day-to-day-activity-icon"
                color="white"
              />
              <div className="text-center text-break py-2">{option.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DayToDay;
